/* import __COLOCATED_TEMPLATE__ from './spares-container.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { CapacitorItem } from './bypass-capacitors-container';

interface SparesContainerCircuitArgs {
  bypassCapacitors: Array<CapacitorItem>;
  opAmpSpares: Array<OpAmpItem>;
  adjustForReferences: boolean;
  adjustForBypassCapacitors: boolean;
  showHelp?: (title: string, message: string, msgparams?: Record<string, unknown>) => void;
}

export type OpAmpItem = {
  circuit: string;
  referenceDesignator: string;
  channelDesignator: string;
  name: string;
  vsPlus: string;
  vsMinus: string;
};

export default class SparesContainerCircuit extends Component<SparesContainerCircuitArgs> {
  get xTranslate(): number {
    const hasRefStage = this.args.adjustForReferences;
    const hasCapacitors = this.args.adjustForBypassCapacitors;
    let sparesPosition = 5;
    if (hasRefStage && hasCapacitors) {
      sparesPosition = 525 + this.args.bypassCapacitors.length * 100;
    }
    if (hasRefStage && !hasCapacitors) {
      sparesPosition = 525;
    }
    if (!hasRefStage && hasCapacitors) {
      sparesPosition = this.args.bypassCapacitors.length * 100;
    }
    return sparesPosition;
  }
  showOpAmpSparesHelp(): void {
    const title = 'help.next-steps.circuit.why-spares.title';
    const message = 'help.next-steps.circuit.why-spares.message';
    if (this.args.showHelp) {
      this.args.showHelp(title, message);
    }
  }
  @action opAmpSparesHelpClick(/*event*/): void {
    return this.showOpAmpSparesHelp();
  }
  @action opAmpSparesHelpEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      return this.showOpAmpSparesHelp();
    }
  }
}
